import { bool, number, string } from 'prop-types';
import UKPriceTable from './UKPriceTable';
import * as classNames from './OrderSummary.module.css';

// const priceInCentsWithCurrency = compose(addCurrency, formatCurrencyInCents);

const OrderSummary = ({
  title,
  total,
  sum,
  country = '',
  footnote,
  isRefillSection: _isRefillSection = false,
  isFreeShipping: _isFreeShipping = false,
  shippingFeeInCents: _shippingFeeInCents = 0,
}) => {
  const tax = Number((sum * 0.2).toFixed(2));

  return (
    <div className={classNames.container}>
      <div className={classNames.title}>
        {title} (
        <span className={classNames.total}>
          {total} {total > 1 ? 'items' : 'item'}
        </span>
        )
      </div>
      {country !== 'GB' && <div className={classNames.sum}>{`$${sum.toFixed(2)}`}</div>}
      {country === 'GB' && <UKPriceTable sum={sum} tax={tax} />}
      {!!footnote && <div className={classNames.footnote}>{footnote}</div>}
      {/* TODO: Add the shipping cost here when we have the correct endpoint on growth api */}
      {/* {isRefillSection && (
        <div className={classNames.shippingCostContainer}>
          <hr />
          <p className={classNames.shippingCost} data-testid="order-summary-shipping-cost">
            {isFreeShipping
              ? 'Free shipping'
              : `+ ${priceInCentsWithCurrency(shippingFeeInCents)} Shipping`}
          </p> 
        </div>
      )}*/}
    </div>
  );
};

OrderSummary.propTypes = {
  title: string.isRequired,
  total: number.isRequired,
  sum: number.isRequired,
  country: string,
  footnote: string.isRequired,
  isRefillSection: bool,
  isFreeShipping: bool,
  shippingFeeInCents: number,
};

export default OrderSummary;
